export const setTitleAndDescription = (title, description) => {
    window.document.title = title
    window.document.head.querySelector('meta[name=description]').content = description
}

export const calRiskFactor = (value) => {
    value = parseInt(value)
    if ( value > 0 && value < 4 ){
        return 0
    } else if (value >= 4 && value < 8) {
        return 1
    } else if (value >= 8 && value < 10) {
        return 2
    } else if (value >= 10) {
        return 3
    } else {
        return 0
    }
}
export const calSymptom = (value) => {
    value = parseInt(value)
    if ( value > 0 && value < 4 ){
        return 0
    } else if (value >= 4 && value < 8) {
        return 1
    } else if (value >= 8 && value < 10) {
        return 2
    } else if (value >= 10) {
        return 3
    } else {
        return 0
    }
}
export const showTrend = (value) => {
    if (value < 0) {
        return '<i class=\'fa fa-arrow-circle-down text-success\'>' + value + '</i>'
    } else if ( value > 0 ) {
        return '<i class=\'fa fa-arrow-circle-up text-danger\'>' + value + '</i>'
    } else if ( value === 0 ) {
        return '<i class=\'fa fa-arrows-v text-info\'>' + value + '</i>'
    }
}
export const showAgeGroup = (value) => {
    var age = new Date().getFullYear() - value
    if ( age > 0 && age < 25 ){
        return 0
    } else if (age >= 25 && age < 45) {
        return 1
    } else if (age >= 45 && age < 55 ) {
        return 2
    } else if (age >= 55) {
        return 3
    } else {
        return 0
    }
}
export const listError = (value) => {
var data = [] 
var type = typeof value
   if (type === 'object' ){
    for (var k in value) {
        if (value.hasOwnProperty(k)) {
            data.push(value[k])
        }
    }
   } else if (type === "string"){
        data.push(value)
   }
   return data
}
export const getIcon = (status) => {
    if (status === 8){
      return "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
    } else if (status === 7){
      return "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
    } else {
      return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
    }
  }


// WEBPACK FOOTER //
// ./src/lib/functions.js